import { Box, Button, CircularProgress, Typography } from '@mui/material';

// =============================================================================
// Types
// =============================================================================

interface ImportProgressStepProps {
  message: string;
  onCancel?: () => void;
  isCancelling?: boolean;
}

// =============================================================================
// Component
// =============================================================================

export const ImportProgressStep = ({
  message,
  onCancel,
  isCancelling = false,
}: ImportProgressStepProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
        gap: 3,
        px: 2,
      }}
    >
      <CircularProgress size={48} />

      <Typography variant="body1" color="text.secondary" textAlign="center">
        {message}
      </Typography>

      {onCancel && (
        <Button
          variant="text"
          size="small"
          onClick={onCancel}
          disabled={isCancelling}
        >
          {isCancelling ? 'Cancelling...' : 'Cancel Import'}
        </Button>
      )}
    </Box>
  );
};

